<template>
  <v-skeleton-loader
    :loading="loading"
    :transition="transition"
    type="date-picker"
  >
    <component :is="component" v-bind="dataProp"></component>
  </v-skeleton-loader>
</template>

<script>
import { GeofencesHelpers } from '@/helpers/mainExports.js'
import { mapGetters } from 'vuex'
import store from '@/store'
import EditCircle from './EditCircle.vue'
import EditPolygon from './EditPolygon.vue'

export default {
  components: {
    EditCircle,
    EditPolygon
  },
  data() {
    return {
      loading: true,
      geofenceData: '',
      id: null,
      name: '',
      routeTo: { name: 'GeofencesList' },
      component: 'EditCircle'
    }
  },

  methods: {
    getComponent(type) {
      switch (type) {
        case 'Circle':
          return 'EditCircle'
        case 'Polygon':
          return 'EditPolygon'
      }
    },
    async getGeofence(currentRoute) {
      try {
        const response = await GeofencesHelpers.getGeofence({
          id: currentRoute,
          _p: 'id,data.properties.name,data.geometry'
        })
        this.loading = false
        if (!response.hasOwnProperty('error')) {
          this.loading = false
          this.geofenceData = response
          this.component = this.getComponent(response.data.geometry.type)
        }
      } catch (error) {
        this.loading = false
        const errorText = GeofencesHelpers.getErrorMessageByCode(error.error)
        const snackbar = {
          text: errorText
        }
        store.dispatch('ui/setSnackbar', snackbar)
        this.$router.push({ name: 'geofences' })
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['session']),
    dataProp() {
      const data = this.geofenceData
      return { geofenceData: data }
    }
  },
  watch: {
    session(newSession) {
      //En caso que al inicio no hubiera una sesión abierta, observamos su estado
      //y cuando la misma este disponible obtenemos los datos
      //Escenario de uso: frente a un reload de página
      if (newSession.isOpen) {
        const currentRoute = this.$route.params.id
        this.getGeofence(currentRoute)
      }
    }
  },
  created() {
    //Si la sesión de la conexión wamp se encuentra abierta obtengo los datos
    if (this.session.isOpen) {
      const currentRoute = this.$route.params.id
      this.getGeofence(currentRoute)
    }
  }
}
</script>

<style lang="scss" scoped></style>
